import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuHeader} from '@Components/contextual-menu/components/contextual-menu-header';
import {ContextualMenuTextHeader} from '@Components/contextual-menu/components/contextual-menu-text-header';
import {noop} from '@Utils/general.util';
import {ContextualMenu} from '@Components/contextual-menu';
import {TranscriptTemplatesPanelContent} from '@Components/poster-editor/components/poster-editing-side-panel/components/transcript-templates-panel/components/transcript-templates-panel-content/transcript-templates-panel-content';
import type {TranscriptTemplatesPanelProps} from './transcript-templates-panel.types';

export function TranscriptTemplatesPanel({
  isLoading = false,
  onBack = noop,
  onTemplateSelected = noop,
  hideAnimationOptionsAndPresets = false,
  ...props
}: TranscriptTemplatesPanelProps): ReactElement<any> {
  const getHeader = (): ReactElement<any> => {
    return (
      <ContextualMenuHeader id="transcript-customize-panel">
        <ContextualMenuTextHeader
          showBackButton
          onBackButton={() => {
            onBack();
          }}
          text={window.i18next.t('pmwjs_presets')}
        />
      </ContextualMenuHeader>
    );
  };

  return (
    <ContextualMenu includeLeftRightPadding={false} contentClassName="spacing-p-t-5" id="transcript-templates" header={getHeader()}>
      <TranscriptTemplatesPanelContent
        isLoading={isLoading}
        selectedTemplateId={props.selectedTemplateId}
        onTemplateSelected={onTemplateSelected}
        hideAnimationOptionsAndPresets={hideAnimationOptionsAndPresets}
      />
    </ContextualMenu>
  );
}
